import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceConfigTokenMovementActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/TokenMove/TokenMoveBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceConfigTokenMovement"
				RenderedComponent={this.RenderedComponent}
				context="FinanceConfigTokenMovement"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceConfigTokenMovementActivity)
